import { Box, Stack, Tooltip } from '@mui/material';

import mt4Icon from '../../assets/images/icons/mt4_logo.png';
import mt5Icon from '../../assets/images/icons/mt5_logo.png';
import cTraderMark from '../../assets/images/icons/ctrader_nameless.webp';
import dxIcon from '../../assets/images/icons/dxtrade_icon.png';
import dxIconDark from '../../assets/images/icons/dxtrade_icon-dark.png';
import tlIcon from '../../assets/images/icons/tradelocker.png';
import tlIconDark from '../../assets/images/icons/tradelocker-dark.png';
import mtrIcon from '../../assets/images/icons/matchTrader.png';
import mtrIconDark from '../../assets/images/icons/matchTrader-dark.png';
import tvIcon from '../../assets/images/icons/tv.png';
import tvIconDark from '../../assets/images/icons/tv-dark.png';
import rithmicIcon from '../../assets/images/icons/rithmic.png';
import ntIcon from '../../assets/images/icons/nt.webp';
import pxIcon from '../../assets/images/icons/projectx.png';

export interface PlatformLogo {
  name: string;
  light: string;
  darkSrc?: string;
}

export const CFD_PLATFORMS: PlatformLogo[] = [
  { name: 'MetaTrader 4', light: mt4Icon },
  { name: 'MetaTrader 5', light: mt5Icon },
  // The round mark, not the wordmark: it sits in an icon row with MT4/MT5.
  { name: 'cTrader', light: cTraderMark },
  { name: 'DXtrade', light: dxIcon, darkSrc: dxIconDark },
  { name: 'TradeLocker', light: tlIcon, darkSrc: tlIconDark },
  { name: 'MatchTrader', light: mtrIcon, darkSrc: mtrIconDark }
];

export const FUTURES_PLATFORMS: PlatformLogo[] = [
  { name: 'Tradovate', light: tvIcon, darkSrc: tvIconDark },
  { name: 'Rithmic', light: rithmicIcon },
  { name: 'NinjaTrader', light: ntIcon },
  { name: 'PROJECT X', light: pxIcon }
];

/** Logo strip shared by the lock panel cards and the quick-subscribe rows. */
export const PlatformLogos = ({ items, dark, size = 18 }: { items: PlatformLogo[]; dark: boolean; size?: number }) => (
  <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
    {items.map((l) => (
      <Tooltip key={l.name} title={l.name}>
        <Box
          component="img"
          src={dark && l.darkSrc ? l.darkSrc : l.light}
          alt={l.name}
          sx={{ height: size, width: 'auto', maxWidth: size * 3.8, objectFit: 'contain', opacity: 0.9 }}
        />
      </Tooltip>
    ))}
  </Stack>
);
